import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/report',
  component: Layout,
  redirect: '/report/index',
  name: 'Report',
  meta: {
    title: '报告管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'ReportIndex',
      component: () => import('@/views/report/index.vue'),
      meta: {
        title: '报告管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/report"
      },
    }
  ],
}

export default routes
